<template>
    <section class="form-questions">
        <div class="carousel-inner">
            <div v-for="page in pages"
                 :key="page"
                 class="carousel-item"
                 :class="{'active': page === 1}"
            >
                <div class="row carousel-item-container m-1">
                    <div class="d-flex content-forms-scroll px-0 align-items-top"
                         :class="'content-forms-scroll-' + identifierId">
                        <div class="col-12">
                            <div v-for="(question, index) in currentQuestions"
                                 :key="question.question_id"
                                 class="form-group"
                            >
                                <div class="content"
                                     v-if="(question.page == page || !hasPages) && question.questionTypeId !== QUESTION_TYPES.BREAK_PAGE">
                                    <div class="item-question">
                                        <contact-information
                                            v-if="question.questionTypeId === QUESTION_TYPES.COLLECT_PERSONAL_INFORMATION"
                                            :enumeration="(index+1)"
                                            :question="question"
                                            :showNumbering="showNumbering"
                                            :translateLabels="translateLabels"
                                            :TYPE_FIELD_ID="QUESTION_TYPES.COLLECT_PERSONAL_INFORMATION"
                                            :store="store"
                                            :has-submitted="hasSubmitted"
                                            @register-field="handleFieldRegister"
                                            @field-change="handleFieldChange"
                                        />

                                        <date-question
                                            v-if="question.questionTypeId === QUESTION_TYPES.DATE_QUESTION"
                                            :enumeration="(index+1)"
                                            :question="question"
                                            :showNumbering="showNumbering"
                                            :translateLabels="translateLabels"
                                            :TYPE_FIELD_ID="QUESTION_TYPES.DATE_QUESTION"
                                            :has-submitted="hasSubmitted"
                                            @register-field="handleFieldRegister"
                                            @field-change="handleFieldChange"
                                        />

                                        <dependent-pulldown
                                            v-if="question.questionTypeId === QUESTION_TYPES.DEPENDENT_PULLDOWN"
                                            :enumeration="(index+1)"
                                            :question="question"
                                            :showNumbering="showNumbering"
                                            :translateLabels="translateLabels"
                                            :TYPE_FIELD_ID="QUESTION_TYPES.DEPENDENT_PULLDOWN"
                                        />

                                        <images-select-multiple
                                            v-if="question.questionTypeId === QUESTION_TYPES.SINGLE_IMAGES_SELECT_MULTIPLE"
                                            :enumeration="(index+1)"
                                            :question="question"
                                            :showNumbering="showNumbering"
                                            :store="store"
                                            :translateLabels="translateLabels"
                                            :TYPE_FIELD_ID="QUESTION_TYPES.SINGLE_IMAGES_SELECT_MULTIPLE"
                                        />

                                        <multi-select-multiple
                                            v-if="question.questionTypeId === QUESTION_TYPES.MULTI_SELECT_MULTIPLE"
                                            :enumeration="(index+1)"
                                            :question="question"
                                            :showNumbering="showNumbering"
                                            :translateLabels="translateLabels"
                                            :TYPE_FIELD_ID="QUESTION_TYPES.MULTI_SELECT_MULTIPLE"
                                            :has-submitted="hasSubmitted"
                                            @register-field="handleFieldRegister"
                                            @field-change="handleFieldChange"
                                            @other-field-data="handleOtherFieldData"
                                        />

                                        <pull-down
                                            v-if="question.questionTypeId === QUESTION_TYPES.PULL_DOWN"
                                            :enumeration="(index+1)"
                                            :question="question"
                                            :showNumbering="showNumbering"
                                            :store="store"
                                            :translateLabels="translateLabels"
                                            :TYPE_FIELD_ID="QUESTION_TYPES.PULL_DOWN"
                                            :has-submitted="hasSubmitted"
                                            @register-field="handleFieldRegister"
                                            @field-change="handleFieldChange"
                                            @other-field-data="handleOtherFieldData"
                                        />

                                        <open-ended-single
                                            v-if="question.questionTypeId === QUESTION_TYPES.OPEN_ENDED_SINGLE"
                                            :enumeration="(index+1)"
                                            :question="question"
                                            :store="store"
                                            :showNumbering="showNumbering"
                                            :TYPE_FIELD_ID="QUESTION_TYPES.OPEN_ENDED_SINGLE"
                                            :has-submitted="hasSubmitted"
                                            @register-field="handleFieldRegister"
                                            @field-change="handleFieldChange"
                                         />

                                        <open-ended-text
                                            v-if="question.questionTypeId === QUESTION_TYPES.OPEN_ENDED_TEXT"
                                            :enumeration="(index+1)"
                                            :question="question"
                                            :store="store"
                                            :showNumbering="showNumbering"
                                            :TYPE_FIELD_ID="QUESTION_TYPES.OPEN_ENDED_TEXT"
                                            :has-submitted="hasSubmitted"
                                            @register-field="handleFieldRegister"
                                            @field-change="handleFieldChange"
                                        />

                                        <rate-items-on-a-scale
                                            v-if="question.questionTypeId === QUESTION_TYPES.RATE_ITEMS_ON_A_SCALE"
                                            :enumeration="(index+1)"
                                            :question="question"
                                            :showNumbering="showNumbering"
                                            :translateLabels="translateLabels"
                                            :TYPE_FIELD_ID="QUESTION_TYPES.RATE_ITEMS_ON_A_SCALE"
                                            :has-submitted="hasSubmitted"
                                            @register-field="handleFieldRegister"
                                            @field-change="handleFieldChange"
                                        />

                                        <rating-items
                                            v-if="question.questionTypeId === QUESTION_TYPES.RATING_ITEMS"
                                            :enumeration="(index+1)"
                                            :question="question"
                                            :showNumbering="showNumbering"
                                            :translateLabels="translateLabels"
                                            :TYPE_FIELD_ID="QUESTION_TYPES.RATING_ITEMS"
                                            :has-submitted="hasSubmitted"
                                            @register-field="handleFieldRegister"
                                            @field-change="handleFieldChange"
                                        />

                                        <single-select-multiple
                                            v-if="question.questionTypeId === QUESTION_TYPES.SINGLE_SELECT_MULTIPLE"
                                            :enumeration="(index+1)"
                                            :question="question"
                                            :showNumbering="showNumbering"
                                            :store="store"
                                            :translateLabels="translateLabels"
                                            :TYPE_FIELD_ID="QUESTION_TYPES.SINGLE_SELECT_MULTIPLE"
                                            :has-submitted="hasSubmitted"
                                            @register-field="handleFieldRegister"
                                            @field-change="handleFieldChange"
                                            @other-field-data="handleOtherFieldData"
                                        />

                                        <terms-and-conditions
                                            v-if="question.questionTypeId === QUESTION_TYPES.TERMS_AND_CONDITIONS"
                                            :enumeration="(index+1)"
                                            :question="question"
                                            :showNumbering="showNumbering"
                                            :translateLabels="translateLabels"
                                            :TYPE_FIELD_ID="QUESTION_TYPES.TERMS_AND_CONDITIONS"
                                            :has-submitted="hasSubmitted"
                                            @register-field="handleFieldRegister"
                                            @field-change="handleFieldChange"
                                        />

                                        <text-block
                                            v-if="question.questionTypeId === QUESTION_TYPES.TEXT_BLOCK"
                                            :question="question"
                                            :TYPE_FIELD_ID="QUESTION_TYPES.TEXT_BLOCK"
                                        />

                                        <hr class="mb-0"
                                            v-if="showSeparator">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script setup>
import { ref, computed, onMounted, nextTick, watch } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import { QUESTION_TYPES } from '@/playerVue3/enums/question-types-enum';
import ContactInformation from "@/playerVue3/components/form/questionTypes/contact-information";
import SingleSelectMultiple from "@/playerVue3/components/form/questionTypes/single-select-multiple.vue";
import MultiSelectMultiple from "@/playerVue3/components/form/questionTypes/multi-select-multiple.vue";
import OpenEndedSingle from "@/playerVue3/components/form/questionTypes/open-ended-single.vue";
import OpenEndedText from "@/playerVue3/components/form/questionTypes/open-ended-text.vue";
import PullDown from "@/playerVue3/components/form/questionTypes/pull-down.vue";
import DependentPulldown from "@/playerVue3/components/form/questionTypes/dependent-pulldown.vue";
import RateItemsOnAScale from "@/playerVue3/components/form/questionTypes/rate-items-on-a-scale.vue";
import DateQuestion from "@/playerVue3/components/form/questionTypes/date-question.vue";
import RatingItems from "@/playerVue3/components/form/questionTypes/rating-items.vue";
import TermsAndConditions from "@/playerVue3/components/form/questionTypes/terms-and-conditions.vue";
import ImagesSelectMultiple from "@/playerVue3/components/form/questionTypes/images-select-multiple.vue";
import TextBlock from "@/playerVue3/components/form/questionTypes/text-block.vue";

// INITIALIZE STORE & COMPOSABLES
const playerStore = usePlayerStore();

// PROPS & EMITS
const props = defineProps({
    additionalPercentageHeight: {
        type: Number,
        required: false,
        default: 0,
    },
    calculateHeight: {
        type: Boolean,
        default: true,
    },
    existValueOther: {
        type: Boolean,
        required: true,
    },
    formSizeClass: {
        type: String,
        required: false,
        default: 'large-form-modal-container',
    },
    hasPages: {
        type: Boolean,
        required: true,
    },
    hotspot: {
        type: Object,
        required: false,
    },
    identifierId: {
        type: Number,
        required: true,
    },
    inputText: {
        type: Boolean,
        required: false,
    },
    pageActive: {
        type: Number,
        required: false,
        default: 1,
    },
    pages: {
        type: Number,
        required: true,
    },
    questionImageRequired: {
        type: Boolean,
        required: false,
    },
    showSeparator: {
        type: Boolean,
        required: false,
        default: true,
    },
    store: {
        type: Object,
        required: true
    },
    translateLabels: {
        type: Object,
        required: true,
    },
    typeIdentifier: {
        type: String,
        required: true,
    },
    valueHeight: {
        type: Number,
        required: false,
        default: 0,
    },
    formErrors: {
        type: Object,
        default: () => ({})
    },
    hasSubmitted: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['register-field', 'field-change', 'other-field-data']);

// Propagar eventos de registro de campos
const handleFieldRegister = (fieldName, initialValue) => {
    emit('register-field', fieldName, initialValue);
};

const handleFieldChange = (fieldName, value) => {
    emit('field-change', fieldName, value);
};

const handleOtherFieldData = (data) => {
    emit('other-field-data', data);
};

// REACTIVE VARIABLES
const currentQuestions = ref([]);

// COMPUTED PROPERTIES
const isVisible = computed(() => {
    if (props.typeIdentifier == 'form'
        && playerStore.getFormData
        && playerStore.getFormClickedFromSidebarData
        && playerStore.getFormData.formId == Number(playerStore.getFormClickedFromSidebarData.customAction)
    ) {
        getHeight();
        return true;
    } else if (props.typeIdentifier == 'hotspot' && playerStore.getActiveHotspot) {
        getHeight();
        return true;
    }
    $('#bottom-button-bar').css({
        opacity: 1, bottom: -50, padding: 0, transition: '0.3s',
    });

    return false;
});

const showNumbering = computed(() => {
    if (props.hotspot !== undefined && props.hotspot.hotspotType.hotspotTypeId == 6) {
        return false;
    }

    if (playerStore.getFormData !== undefined) {
        return Boolean(playerStore.getFormData.showNumbering);
    }
    return false;
});

// METHODS
const funcCalculateHeight = () => {
    let hotspotID = 0;
    hotspotID = props.identifierId;
    let hotspotOverlayHeight = 0;
    let additionalPercentageHeight = props.additionalPercentageHeight;
    const videoOrientation = playerStore.getVideoOrientation;
    if (videoOrientation === 'vertical') {
        additionalPercentageHeight = 17;
    }
    let height = 0;
    height = window.innerHeight;
    // Alto del overlay
    if (window.innerWidth > 991) {
        hotspotOverlayHeight = document.getElementById('hotspot-overlay').clientHeight;
    } else {
        hotspotOverlayHeight = document.getElementById('form-template-' + hotspotID).clientHeight;
    }
    if (videoOrientation !== 'horizontal' && videoOrientation !== 'vertical') {
        $('.divFormScroll-' + hotspotID + '-page' + props.pageActive).css("height", '');
    } else if (props.calculateHeight == true) {
        //let maxHeightPercentage = 0;
        let valueHeight = 0;
        //const containerTemplate = $('#form-template-' + hotspotID);
        let containerCloseBtn = additionalPercentageHeight;
        if (window.innerWidth <= 991) {
            containerCloseBtn = $('.container-close-' + hotspotID).length > 0 ? ($('.container-close-' + hotspotID).outerHeight() + additionalPercentageHeight) : 0;
        }
        const containerTemplateHeader = $('.class-template-header-' + hotspotID).length > 0 ? $('.class-template-header-' + hotspotID).outerHeight() : 0;
        const containerTemplateFooter = $('.class-template-footer-' + hotspotID).length > 0 ? $('.class-template-footer-' + hotspotID).outerHeight() : 0;
        const textMandatory = $('.text-mandatory-' + hotspotID).length > 0 ? $('.text-mandatory-' + hotspotID).outerHeight() : 0;
        //maxHeightPercentage = 100 - (((containerTemplateHeader + containerTemplateFooter + containerCloseBtn + textMandatory) * 100 / containerTemplate.outerHeight()));
        valueHeight = ((hotspotOverlayHeight - (containerTemplateHeader + containerTemplateFooter + containerCloseBtn + textMandatory)) * 100) / height;
        $('.content-forms-scroll-' + hotspotID).css("height", (valueHeight - 0.7) + 'vh');
    }
};

const getHeight = () => {
    if (props.formSizeClass !== 'small-form-modal-container') {
        setTimeout(() => {
            if (props.typeIdentifier == 'form'
                && playerStore.getFormData
                && playerStore.getFormClickedFromSidebarData
                && playerStore.getFormData.formId == Number(playerStore.getFormClickedFromSidebarData.customAction)
            ) {
                nextTick(() => {
                    funcCalculateHeight();
                });
            } else if (props.typeIdentifier == 'hotspot' && playerStore.getActiveHotspot) {
                nextTick(() => {
                    funcCalculateHeight();
                });
            }
        }, 1000)
    }
};

const initResize = () => {
    $(window).resize(function () {
        setTimeout(() => {
            funcCalculateHeight();
        }, 500);
    });
};

// LYFECYCLE HOOKS
watch(isVisible, () => {
    getHeight(props.identifierId);
});

onMounted(() => {
    let page = 1;
    let currentNumQuestion = 0;
    let breakPage = 0;
    currentQuestions.value = [];
    const dataQuestionByHotspot = Object.assign({}, playerStore.getFormQuestions(props.identifierId, props.typeIdentifier));
    if (Object.keys(dataQuestionByHotspot).length > 0) {
        if (props.pages > 0) {
            const numQuestionByPage = Math.ceil(dataQuestionByHotspot[0]['data'].length / props.pages);
            for (let i = 0; i < dataQuestionByHotspot[0]['data'].length; i++) {
                let itemObj = Object.assign({}, dataQuestionByHotspot[0]['data'][i])
                if (itemObj['questionTypeId'] === QUESTION_TYPES.BREAK_PAGE) {
                    breakPage++;
                }
                currentNumQuestion++;
                itemObj['page'] = page;
                currentQuestions.value.push(itemObj)
                if (breakPage > 0 && (parseInt(currentNumQuestion) > parseInt(numQuestionByPage))) {
                    page++;
                    breakPage = 0;
                    currentNumQuestion = 0;
                }
            }
        }
    }
    initResize();
});
</script>
